<div class="container-fluid">
	<h1>{{ '401_Title' | translate }}</h1>

	<h2 *ngIf="reasonTranslationKey">
		{{ reasonTranslationKey | translate }}
	</h2>
</div>